'use client';

import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogClose } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { ComparisonTable } from './ComparisonTable';
import { VerticalLine } from '../../../types';

interface ComparisonTableModalProps {
  open: boolean;
  onClose: () => void;
  sensors: string[];
  verticalLines: VerticalLine[];
  enabledSensors: Record<string, boolean>;
  onToggleSensor: (sensorName: string) => void;
  onRemoveVerticalLine: (id: string) => void;
  onClearAllLines: () => void;
  sensorColors: Record<string, string>;
  dataTypes?: string[];
  sectionType: string;
  onAddSensor?: (sensorName: string) => void;
  loadingSensors?: Set<string>;
}

export const ComparisonTableModal = ({
  open,
  onClose,
  sensors,
  verticalLines,
  enabledSensors,
  onToggleSensor,
  onRemoveVerticalLine,
  onClearAllLines,
  sensorColors,
  dataTypes = [],
  sectionType,
  onAddSensor,
  loadingSensors = new Set(),
}: ComparisonTableModalProps) => {
  return (
    <Dialog open={open} onOpenChange={(val) => !val && onClose()}>
      <DialogContent className="max-w-6xl overflow-hidden p-0">
        <DialogHeader className="p-4 border-b">
          <DialogTitle className="text-lg">Sensor Comparison Table</DialogTitle>
        </DialogHeader>
        <div className="p-4 overflow-auto max-h-[80vh]">
          <ComparisonTable
            sensors={sensors}
            verticalLines={verticalLines}
            enabledSensors={enabledSensors}
            onToggleSensor={onToggleSensor}
            onRemoveVerticalLine={onRemoveVerticalLine}
            onClearAllLines={onClearAllLines}
            sensorColors={sensorColors}
            dataTypes={dataTypes}
            sectionType={sectionType}
            onAddSensor={onAddSensor}
            loadingSensors={loadingSensors}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};
